<div class="mainContentContainer">
  <div style="padding-bottom: 60px;">
    <form #profileForm="ngForm">
      <div class="view-container">
        <app-content-header headline="Publisher profile"></app-content-header>
        <mat-form-field appearance="outline">
          <mat-label>Full name</mat-label>
          <input matInput placeholder="Full name"
                 name="full_name"
                 required
                 [(ngModel)]="name">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="email"
                 name="email_address"
                 required
                 readonly
                 type="email"
                 [(ngModel)]="email">
        </mat-form-field>
      </div>

      <div class="view-container">
        <app-content-header headline="Password"></app-content-header>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Current Password</mat-label>
            <input matInput placeholder="password"
                   name="current_password"
                   [type]="hidePassword ? 'password' : 'text'"
                   [(ngModel)]="currentPassword">
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>New password</mat-label>
            <input matInput placeholder="password"
                   name="new_password"
                   appStrongPasswordValidator
                   [required]="currentPassword.length > 0"
                   [type]="hideNewPassword ? 'password' : 'text'"
                   [(ngModel)]="newPassword">
            <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword">
              <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <mat-error *ngIf="profileForm.controls['new_password'] && profileForm.controls['new_password'].touched && profileForm.controls['new_password'].invalid">Password minimum length is 8 characters, also the password must contain at least one lower case, one uppercase, one number and one symbol.</mat-error>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Confirm new password</mat-label>
            <input matInput placeholder="password"
                   name="new_password2"
                   appStrongPasswordValidator
                   [required]="currentPassword.length > 0"
                   appPasswordValidator
                   [password]="newPassword"
                   [type]="hideNewPassword2 ? 'password' : 'text'"
                   [(ngModel)]="newPasswordConfirmation">
            <button mat-icon-button matSuffix (click)="hideNewPassword2 = !hideNewPassword2"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword2">
              <mat-icon>{{hideNewPassword2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="newPassword !== newPasswordConfirmation">
              Passwords do not match.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <app-bottom-bar positiveLabel="Save" (positiveAction)="save()"
                  [positiveDisabled]="!profileForm.valid || !valueChangeDetected" cdkFocusInitial></app-bottom-bar>
</div>
